import React, { useState } from 'react';
import { sleep } from 'simple-utils';
import { Bot, logoutBot, resetBot, stopBot } from '../bot-loaders';
import { LoadingButton } from '../components/SavingButton';
import { useAddToast } from '../components/Toasts';
import { MessageBox } from "../comps/MessageBox";
import { logBotEvent } from '../ga/ga-event-logger';

type ResetAction = "reset" | "stop" | "logout"

export function ResetActionConfirm({question, hint, actionLabel, onAction, onCancel}:{question:string, hint:string, actionLabel:string, onAction:()=>Promise<void>, onCancel:()=>void}){
    const [loading, setLoading] = useState(false)
    const addToast = useAddToast();

    async function doAction(){
        if(loading) return;
        setLoading(true);
        try{
            await onAction()
        }catch(e){
            addToast(<>Erro ao executar a ação</>, "bg-danger");
        }
        setLoading(false);
    }

    return <>
        <div className='mb-3'>
            {question}
            <small className='text-muted d-block mt-2'>{hint}</small>
        </div>
        <div className="">
            <a className="btn btn-primary mb-2 me-2" onClick={loading ? ()=> {} : onCancel}>Voltar</a>
            <LoadingButton saving={loading} className="btn btn-danger mb-2 me-2" onClick={doAction}>{actionLabel}</LoadingButton>
        </div> 
    </>
}

export function BotResetDialog({onAction, bot, showMessage = false}:{showMessage?: boolean, bot: Bot, onAction:(newBot:Bot)=>void}){
    const [resetAction, setResetAction] = useState<ResetAction>(null);

    function onCancel(){
        setResetAction(null);
    }

    async function doAction(){
        await sleep(1000); 
        var newBot:Bot = null;
        switch(resetAction){
            case "reset": newBot = await resetBot(bot); break;
            case "stop": newBot = await stopBot(bot); break;
            case "logout": newBot = await logoutBot(bot); break;
        } 

        logBotEvent(bot, resetAction);
        
        if(newBot)
            onAction(newBot);
    }

    return (<>
        {showMessage && <MessageBox icon="fa fa-exclamation-triangle" className="mb-3 mt-3">
            <div className="mb-2"><b>Atenção:</b> Após a leitura do QR code, caso seu WhatsApp demore mais de 4 minutos para logar, clique no botão abaixo para desconectar para iniciar a autenticação novamente.</div>
        </MessageBox>}
        { resetAction == null && <>
            <div className='mb-3'>
                Qual das ações você deseja executar?<br />
                <small className='text-muted d-block mt-2'>
                    Ao clicar em uma delas será explicado os efeitos da ação, 
                    e você deverá confimar se realmente deseja prosseguir.</small>
            </div>
            <div className="">
                <a className="btn btn-primary mb-2 me-2" onClick={()=>setResetAction('reset')}>Reiniciar</a>
                <a className="btn btn-primary mb-2 me-2" onClick={()=>setResetAction('stop')}>Parar</a>
                <a className="btn btn-primary mb-2 me-2" onClick={()=>setResetAction('logout')}>Desconectar</a>
            </div> 
            </> }
        { resetAction == "reset" && <ResetActionConfirm 
            actionLabel='Reiniciar'
            hint='Ao reiniciar, o bot irá ser parado, e logo em seguida iniciado. É o equivalente de atuliazar a página do WhatsApp Web.'
            question='Deseja reiniciar o bot?'
            onAction={doAction}
            onCancel={onCancel}
            /> }
        { resetAction == "stop" && <ResetActionConfirm 
            actionLabel='Parar'
            hint='Ao parar, o bot irá ser encerrado mas não será necessário ler o QR Code quando for iniciado no futuro.'
            question='Deseja parar o bot?'
            onAction={doAction}
            onCancel={onCancel}
            /> }
        { resetAction == "logout" && <ResetActionConfirm 
            actionLabel='Desconectar'
            hint='Ao desconectar, o bot irá ser parado, a sessão apagada. Quando for iniciar o bot no futuro, a leitura do QR Code será necessária.'
            question='Deseja desconectar o bot?'
            onAction={doAction}
            onCancel={onCancel}
            /> }
    </>)
}